<template>
  <div class="musicbox__detail">
    <div class="detail-header">设备状态</div>
    <div class="detail-item">
      <span class="detail-item__label">设备编号:</span>
      <span class="detail-item__value">{{ data.sn }}</span>
    </div>
    <div class="detail-item">
      <span class="detail-item__label">设备名称:</span>
      <span class="detail-item__value">{{ data.name }}</span>
    </div>
    <div class="detail-item">
      <span class="detail-item__label">运行状态:</span>
      <span class="detail-item__value">
        <SensorState class="clickable" @click.native="handleClick" :runstate="runstate" />
      </span>
    </div>
    <div class="detail-item">
      <span class="detail-item__label">报警状态:</span>
      <span class="detail-item__value">
        <SensorState
          class="clickable"
          @click.native="handleClick"
          :state="state"
          normalColor="#03b36e"
        />
      </span>
    </div>
  </div>
</template>

<script>
import SensorState from '@/components/musicbox/icon/sensor-state.vue';
import { stateFormater } from '@/utils/deviceUtils/state';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  inject: ['showAlarmPopup', 'hideAlarmPopup'],
  components: {
    SensorState
  },
  computed: {
    sn() {
      return this.data.sn;
    },
    runstate() {
      const runstate = this.data.runstate;
      return isNaN(runstate) ? 0 : runstate;
    },
    state() {
      return stateFormater(this.runstate, this.data.state2);
    }
  },
  methods: {
    handleClick() {
      if (this.state > 0 || this.runstate > 1) {
        this.hideAlarmPopup();
        this.showAlarmPopup(this.sn);
      }
    }
  }
};
</script>

<style lang="scss">
.musicbox__detail {
  display: flex;
  flex-wrap: wrap;
  margin: 0 10px;
  border-left: 1px solid #00ffff;
  border-top: 1px solid #00ffff;
  .clickable {
    cursor: pointer;
  }
  & > * {
    box-sizing: border-box;
    border-right: 1px solid #00ffff;
    border-bottom: 1px solid #00ffff;
  }
  & > .detail-header {
    flex: 1;
    min-width: 100%;
    text-align: center;
    background: #183449;
    padding: 10px 0;
    color: #3ff;
    font-size: 16px;
  }
  & > .detail-item {
    min-width: 50%;
    max-width: 50%;
    padding: 15px 0;
    font-size: 16px;
    text-align: center;
    display: flex;
    align-items: center;
    .detail-item__label {
      display: inline-block;
      width: 100px;
      color: $primary-text-color;
    }
    .detail-item__value {
      display: inline-block;
    }
  }
}
</style>
